import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {NgbAlertModule, NgbCarouselModule} from '@ng-bootstrap/ng-bootstrap';
import {HomeRoutingModule} from './home-routing.module';
import {HomeComponent} from './home.component';
import {PageHeaderModule, StatModule} from '../../shared';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NgxPaginationModule} from 'ngx-pagination';
import {FormModule} from '../form/form.module';
import {NgxSpinnerModule} from 'ngx-spinner';
import {JockeyValetComponent} from "./jockey-valet/jockey-valet.component";
import {ApplicationFormComponent} from "./application-form/application-form.component";
import {JockeyAgentComponent} from "./jockey-agent/jockey-agent.component";
import { ApprenticeApplicationComponent } from './apprentice-application/apprentice-application.component';

@NgModule({
    imports: [
        CommonModule,
        NgbCarouselModule,
        NgbAlertModule,
        HomeRoutingModule,
        StatModule,
        NgxPaginationModule,
        FormsModule,
        FormModule,
        ReactiveFormsModule,
        PageHeaderModule,
        NgxSpinnerModule
    ],
    declarations: [HomeComponent, JockeyValetComponent, JockeyAgentComponent, ApplicationFormComponent, ApprenticeApplicationComponent]
})
export class HomeModule {}
